"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueryField = void 0;
var QueryField = /** @class */ (function () {
    function QueryField() {
    }
    QueryField.run = function (data, query) {
        if (!data.hasOwnProperty(query.field)) {
            throw new Error("No field in data \"" + query.field + "\"");
        }
        var target = data[query.field];
        var value = query.value;
        var operations = {
            '==': this.equal,
            'equal': this.equal,
            '<': this.lessThan,
            'lessThan': this.lessThan,
            'less-than': this.lessThan,
            'less_than': this.lessThan,
            '<=': this.lessThanEqual,
            'lessThanEqual': this.lessThanEqual,
            'less-than-equal': this.lessThanEqual,
            'less_than_equal': this.lessThanEqual,
            '>': this.greaterThan,
            'greaterThan': this.greaterThan,
            'greater-than': this.greaterThan,
            'greater_than': this.greaterThan,
            '>=': this.greaterThanEqual,
            'greaterThanEqual': this.greaterThanEqual,
            'greater-than-equal': this.greaterThanEqual,
            'greater_than_equal': this.greaterThanEqual,
            '!=': this.notEqual,
            'notEqual': this.notEqual,
            'not-equal': this.notEqual,
            'not_equal': this.notEqual,
            'array-contains': this.arrayContains,
            'array_contains': this.arrayContains,
            'arrayContains': this.arrayContains,
            'array-contains-any': this.arrayContainsAny,
            'array_contains_any': this.arrayContainsAny,
            'arrayContainsAny': this.arrayContainsAny,
            'in': this.operatorIn,
            'notIn': this.operatorNotIn,
            'not-in': this.operatorNotIn,
            'not_n': this.operatorNotIn
        };
        if (!operations.hasOwnProperty(query.operation)) {
            throw new Error("No operation for \"" + query.operation + "\" found");
        }
        return operations[query.operation](target, value);
    };
    QueryField.lessThanEqual = function (target, value) {
        return target <= value;
    };
    QueryField.lessThan = function (target, value) {
        return target < value;
    };
    QueryField.equal = function (target, value) {
        return target === value;
    };
    QueryField.greaterThan = function (target, value) {
        return target > value;
    };
    QueryField.greaterThanEqual = function (target, value) {
        return target >= value;
    };
    QueryField.notEqual = function (target, value) {
        return target !== value;
    };
    QueryField.arrayContains = function (target, value) {
        return target.indexOf(value) > -1;
    };
    QueryField.arrayContainsAny = function (target, values) {
        for (var _i = 0, values_1 = values; _i < values_1.length; _i++) {
            var v = values_1[_i];
            if (this.arrayContains(target, v)) {
                return true;
            }
        }
        return false;
    };
    QueryField.operatorIn = function (target, value) {
        return this.arrayContainsAny(target, value);
    };
    QueryField.operatorNotIn = function (target, value) {
        return !this.arrayContainsAny(target, value);
    };
    return QueryField;
}());
exports.QueryField = QueryField;
